'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

// only supported format = "hh:mm", seconds are not supported
exports.default = function (timeString) {
    var tokens = timeString.split(':');
    if (tokens.length !== 2) {
        throw new Error('Time string format incorrect, expecting HH:mm, actual: ' + timeString);
    }
    var h = +tokens[0];
    var m = +tokens[1];

    return h * 3600 + m * 60;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/date/timeStringToSeconds.js
// module id = 571
// module chunks = 0